import { FC, HTMLAttributes, ReactNode } from 'react'
import './Modal.scss'
import classNames from 'classnames'
import { ModalHeader } from './ModalHeader'
import { ModalCloseButton } from './ModalCloseButton'
import { useHotkey } from '../../hooks/useHotkey'

interface Props extends HTMLAttributes<HTMLDivElement> {
  close: () => void
  header: ReactNode
}

export const Modal: FC<Props> = ({ header, close, className, children, ...attrs }) => {
  useHotkey(({ key }) => key === 'Escape', close)

  return (
    <div className="Modal" {...attrs}>
      <div className={classNames('body', className)}>
        <ModalCloseButton close={close} />

        <ModalHeader>{header}</ModalHeader>

        {children}
      </div>

      <div className="background" onClick={close} />
    </div>
  )
}
